import { extend, localize } from 'vee-validate'
import {
  required as rule_required,
  email as rule_email,
  min as rule_min,
  confirmed as rule_confirmed,
  regex as rule_regex,
  between as rule_between,
  alpha as rule_alpha,
  integer as rule_integer,
  digits as rule_digits,
  alpha_dash as rule_alpha_dash,
  alpha_num as rule_alpha_num,
  length as rule_length,
} from 'vee-validate/dist/rules'
import ar from 'vee-validate/dist/locale/ar.json'
import en from 'vee-validate/dist/locale/en.json'
import pt_BR from 'vee-validate/dist/locale/pt_BR.json'

import {
  limitParcel,
  ValidatorDueDate,
  validatorPositive,
  validatorUrlValidator,
  validatorPassword,
  validatorCreditCard,
  validatorDocument,
  validatorPhone,
  validatorDate,
  validatorCEP,
  ValidatorBornDate,
  validatorFees,
  validatorValue,
  validatorCVV,
  validatorCheckbox,
  validatorRecurrenceDate,
  validatorRecurrenceDateFinal,
  validatorRecurrenceValue,
  validatorPDF,
  validatorDateRecurrence,
  validatorBinLocked,
} from './validators'

// ////////////////////////////////////////////////////////
// General
// ////////////////////////////////////////////////////////

localize('pt_BR', pt_BR)

export const required = extend('required', rule_required)

export const email = extend('email', rule_email)

export const min = extend('min', rule_min)

export const confirmed = extend('confirmed', rule_confirmed)

export const regex = extend('regex', rule_regex)

export const between = extend('between', rule_between)

export const alpha = extend('alpha', rule_alpha)

export const integer = extend('integer', rule_integer)

export const digits = extend('digits', rule_digits)

export const alphaDash = extend('alpha-dash', rule_alpha_dash)

export const alphaNum = extend('alpha-num', rule_alpha_num)

export const length = extend('length', rule_length)

export const pdfFile = extend('pdf', {
  validate: validatorPDF,
  message: 'Arquivo deve estar em PDF',
})

export const limitParcels = extend('limitParcel', {
  validate: limitParcel,
  message: 'Número da parcela Incorreto',
})

export const positive = extend('positive', {
  validate: validatorPositive,
  message: 'Informe um número positivo!',
})

export const credit = extend('credit-card', {
  validate: validatorCreditCard,
  message: 'Cartão de crédito não é válido',
})

export const binLocked = extend('binLocked', {
  params: ['locked'], 
  validate: validatorBinLocked,
  message: 'Número de cartão Inválido, verifique o número inserido.',
})

export const password = extend('password', {
  validate: validatorPassword,
  message: 'Sua senha deve conter 8 ou mais caracteres, letras maiúsculas e minúsculas, pelo menos um número e um caracter especial',
})

export const url = extend('url', {
  validate: validatorUrlValidator,
  message: 'URL is invalid',
})

export const document = extend('document', {
  validate: validatorDocument,
  message: 'Digite um documento válido',
})

export const phone = extend('phone', {
  validate: validatorPhone,
  message: 'Digite um telefone válido',
})

export const dueDate = extend('dueDate', {
  validate: ValidatorDueDate,
  message: 'Digite uma data correta para vencimento',
})

export const dueDateRecurrence = extend('dueDateRecurrence', {
  validate: validatorDateRecurrence,
  message: 'Digite uma data correta para vencimento',
})

export const firstCharge = extend('firstCharge', {
  validate: ValidatorDueDate,
  message: 'Digite uma data correta para primeira cobrança',
})

export const bornDate = extend('bornDate', {
  validate: ValidatorBornDate,
  message: 'Você deve ter mais de 10 anos',
})

export const ValidatorFees = extend('ValidatorFees', {
  validate: validatorFees,
  message: 'O juros precisa estar entre 1% e 7%',
})

export const date = extend('date', {
  validate: validatorDate,
  message: 'Selecione uma data válida',
})

export const cep = extend('cep', {
  validate: validatorCEP,
  message: 'Digite um CEP válido',
})

export const value = extend('value', {
  validate: validatorValue,
  message: 'Digite um valor válido',
})

export const cvv = extend('cvv', {
  validate: validatorCVV,
  message: 'Digite um CVV válido',
})

export const requiredCheckbox = extend('requiredCheckbox', {
  validate: validatorCheckbox,
  message: 'É obrigatório aceitar os termos de condição de uso',
})

export const validationRecurrenceDate = extend('recurrenceDate', {
  validate: validatorRecurrenceDate,
  message: 'Digite uma data 3 dias após o vencimento do link',
})

export const validationRecurrenceDateFinal = extend('recurrenceDateFinal', {
  validate: validatorRecurrenceDateFinal,
  message: 'Digite um data sem ser dia 29, 30 ou 31',
})

export const validationRecurrenceValue = extend('recurrenceValue', {
  validate: validatorRecurrenceValue,
  message: 'A recorrência precisa ser maior que R$ 10,00',
})

// Install English and Arabic localizations.
localize({
  en: {
    messages: en.messages,
    names: {
      email: 'Email',
      password: 'Password',
    },
    fields: {
      password: {
        min: '{_field_} is too short, you want to get hacked?',
      },
    },
  },
  ar: {
    messages: ar.messages,
    names: {
      email: 'البريد الإلكتروني',
      password: 'كلمة السر',
    },
    fields: {
      password: {
        min: 'كلمة السر قصيرة جداً سيتم اختراقك',
      },
    },
  },
  pt_BR: {
    message: pt_BR.messages,
    names: {
      confirmed: 'As senhas não coincidem',
    },
  },
})
// ////////////////////////////////////////////////////////
// NOTE:
// Quasar validation for reference only
// Remove this note once development is finished and make sure to
// to convert all of them in veevalidate version
// ////////////////////////////////////////////////////////

// export const required = (val) => {
//   return (val && val.length > 0) || '*Field is required'
// }

// export const required_obj = (obj) => {
//   if (obj === null || obj === undefined) return '*Field is required'
//   return (Object.entries(obj).length > 0 && obj.constructor === Object) || '*Field is required'
// }

// export const no_blank_spaces_arr = (arr) => {
//   return arr.every(val => (val.trim() && val.trim().length > 0)) || 'Blank Spaces are not allowed'
// }

// export const url = val => {
//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   // Used
//   // https://stackoverflow.com/questions/4314741/url-regex-validation

//   // Other
//   // https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
//   // https://www.w3resource.com/javascript-exercises/javascript-regexp-exercise-9.php
//   // https://www.geeksforgeeks.org/how-to-validate-url-using-regular-expression-in-javascript/

//   /* eslint-disable no-useless-escape */
//   const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
//   /* eslint-enable no-useless-escape */
//   return re.test(val) || 'URL is invalid'
// }

// export const date = val => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   // https://github.com/quasarframework/quasar/blob/dev/ui/src/utils/patterns.js
//   return /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(val) || 'Date is invalid'
// }

// export const max = (val, max) => {

//   // If blank return
//   if (val === undefined || val === null) return true

//   return val.length <= max || `More than ${max} characters are not allowed`
// }

// export const max_arr = (val, max) => {
//   return val.length <= max || `More than ${max} values are not allowed`
// }

// export const min = (val, min) => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   return val.length >= min || `Minimum ${min} characters are required`
// }

// export const num_range = (val, min, max) => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   const msg = 'Value is invalid'
//   if (min === null) return val <= max || msg
//   else if (max === null) return val >= min || msg
//   else return (val >= min && val <= max) || msg
// }
